import MsForm from './src/index.vue'
import { PROVIDE_KEY } from './src/useAsValidateContainer'

export default MsForm
export { PROVIDE_KEY }
